import type { FaireProductEntity } from "../../entity_types/product";

export const p_hwuhk2jskt: FaireProductEntity = {
  token: "p_hwuhk2jskt",
  type: "product",
  name: "Elephant Reed Oil Diffuser",
  brandToken: "b_6qajwqdzz3",
  brandName: "BigMouth Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/c222b7417f2f4c00a347843897b92c1d68ad758397f57edf00e68bac0b915f03.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1e0cce30152b6dbf47df93072a0347350c140d4672802f8f9664ad45e93739e.jpeg",
    "https://cdn.faire.com/fastly/5b6027728e98e1d481382a09ceed0e7b9c71f811d234d9eb783a6e0e1b3dc4e7.jpeg",
    "https://cdn.faire.com/fastly/89eabb95850bdab36579c7c5472a51d9803111c7e8ec1993695c1d9260a20d11.jpeg",
    "https://cdn.faire.com/fastly/ca2d99ec9ceec8a405f3ef754e236d8a5ee0abbec36032a70a830b61a906b643.jpeg",
    "https://cdn.faire.com/fastly/65c47750764c3d66f1b7bffa96dc891bf67c6d6da4be88256d2164e643b4c567.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "🌟 Continuous Fragrance: Get ready for a scent sensation that lasts and lasts, just like an elephant's memory! With 6 rattan sticks and a 100% eucalyptus essential oil bottle included, our Elephant Reed Oil Diffuser promises to keep your space smelling fantastic for weeks on end, leaving a scent memory that even an elephant would envy. 🏠 Versatile Placement: This diffuser is as versatile as an elephant's trunk! Whether it's your bedroom, kitchen, bathroom, or even your home office, our diffuser brings a touch of elephant-sized charm to every room. 🎉 Easy to Use: Simply insert the reeds and let the magic happen – it's as easy as peanuts for an elephant!",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:07.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
